import { FieldArrayWithId, useFormContext } from "react-hook-form";
import { IPromotion } from "../../../../../types/Marketing/Promotion";
import { Box, IconButton, Typography } from "@mui/material";
import { useDisable } from "../../../../../hooks/use-disable";
import ControlledTextField from "../../../../Controller/ControlledTextField";
import { CustomizedTooltip } from "../../../../Custom/CustomizedTooltip";
import LaunchIcon from "@mui/icons-material/Launch";

type Props = {
  field: FieldArrayWithId<
    IPromotion,
    "item_condition" | "redeem_item",
    "unique_id"
  >;
  index: number;
  fieldArrayName: "item_condition" | "redeem_item";
};

const ItemNameCell = ({ field, index, fieldArrayName }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IPromotion>();
  const [disabled] = useDisable();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "stretch",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          textAlign: "left",
        }}
      >
        {disabled ? (
          <Typography
            variant="body2"
            align="left"
            color="primary"
            onClick={() =>
              window.open(
                `/inventory/items/${field.item_sku_name}?tab=item&subtab=general`,
                "_blank"
              )
            }
            sx={{ cursor: "pointer" }}
          >
            {field.item_name}
          </Typography>
        ) : (
          <ControlledTextField
            disabled
            placeholder="ชื่อสินค้า"
            control={control}
            error={Boolean(
              errors[fieldArrayName] &&
                errors[fieldArrayName]?.[index] &&
                errors[fieldArrayName]?.[index]?.item_name
            )}
            name={`${fieldArrayName}.${index}.item_name`}
          />
        )}
        <Typography
          variant="overline"
          sx={{
            my: 0,
            ml: !disabled ? 2 : 0,
            color: "rgba(0, 0, 0, 0.6)",
          }}
        >
          {field.item_sku_name}
        </Typography>
      </Box>
      {!disabled && (
        <CustomizedTooltip title="กดเพื่อดูรายละเอียดสินค้า">
          <IconButton
            size="small"
            sx={{
              color: "secondary.main",
              alignSelf: "flex-start",
              pt: 1,
            }}
            onClick={() =>
              window.open(
                `/inventory/items/${field.item_sku_name}?tab=item&subtab=general`,
                "_blank"
              )
            }
          >
            <LaunchIcon fontSize="small" />
          </IconButton>
        </CustomizedTooltip>
      )}
    </Box>
  );
};

export default ItemNameCell;
